import loadScript from 'load-script'

let promise

export function getEditorNamespace (editorURL) {
  if ('CKEDITOR' in window) {
    // eslint-disable-next-line no-undef
    return Promise.resolve(CKEDITOR)
  }

  if (editorURL.length < 1) {
    throw new TypeError('CKEditor URL must be a non-empty string.')
  }

  if (!promise) {
    promise = getEditorNamespace.scriptLoader(editorURL).then(res => {
      promise = undefined
      return res
    })
  }

  return promise
}

// eslint-disable-next-line promise/param-names
getEditorNamespace.scriptLoader = editorURL => new Promise((scriptResolve, scriptReject) => {
  loadScript(editorURL, err => {
    if (err) {
      return scriptReject(err)
    } else if (!window.CKEDITOR) {
      return scriptReject(new Error('Script loaded from editorUrl doesn\'t provide CKEDITOR namespace.'))
    }

    // eslint-disable-next-line no-undef
    scriptResolve(CKEDITOR)
  })
})
